import type { ReactNode } from "react";
import type { FormatOptionLabelMeta, StylesConfig } from "react-select";
import type { Option } from "shared/components";
import { cx } from "shared/utils/classnames";
import { formatSenderOptionLabel } from "../utils/senderOption";

export const FOOTER_PILL_STYLES: StylesConfig = {
  control: (base, state) => ({
    ...base,
    cursor: "pointer",
    minHeight: 40,
    height: 40,
    minWidth: 0,
    flexWrap: "nowrap",
    borderColor: "#1C1D221A",
    borderRadius: 8,
    backgroundColor: state.isDisabled ? "rgba(28,29,34,0.040)" : "#fff",
    boxShadow: "0px 1px 2px 0px rgba(28,29,34,0.05)"
  }),
  valueContainer: (base) => ({
    ...base,
    minWidth: 0,
    flexWrap: "nowrap",
    padding: "0 0 0 8px"
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: 13,
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "0 8px 0 4px"
  }),
  placeholder: (base) => ({
    ...base,
    fontSize: 13,
    whiteSpace: "nowrap"
  })
};

const FOOTER_PILL_ICON_STYLES: StylesConfig = {
  ...FOOTER_PILL_STYLES,
  placeholder: (base) => ({ ...base, display: "none" }),
  valueContainer: (base) => ({
    ...base,
    minWidth: 0,
    flexWrap: "nowrap",
    padding: "0 0 0 6px"
  })
};

export const footerPillClassName = ({ isNarrow }: { isNarrow: boolean }) =>
  cx(
    "!text-content-1000 !font-medium",
    isNarrow ? "!min-w-0" : "!min-w-[200px]"
  );

export const footerFromPillProps = ({
  isNarrow,
  valueIcon
}: {
  isNarrow: boolean;
  valueIcon: ReactNode;
}) => ({
  className: footerPillClassName({ isNarrow }),
  styles: isNarrow ? FOOTER_PILL_ICON_STYLES : FOOTER_PILL_STYLES,
  formatOptionLabel: (option: Option, meta: FormatOptionLabelMeta<Option>) =>
    isNarrow && meta.context === "value"
      ? valueIcon
      : formatSenderOptionLabel(option, meta)
});

const WARNING_BORDER_COLOR = "#F4A107";

export const withWarningBorder = (styles: StylesConfig): StylesConfig => ({
  ...styles,
  control: (base, state) => ({
    ...(styles.control ? styles.control(base, state) : base),
    borderColor: WARNING_BORDER_COLOR,
    "&:hover": { borderColor: WARNING_BORDER_COLOR }
  })
});
